import modalStore from 'shared/ui/Modal/store/modalStore'
import { applyOrganizationNamePlaceholder } from 'pages/settings/pages/rcsV2/lib/applyOrganizationNamePlaceholder'

import { RCS_EXAMPLE_CONTENT, type IRcsExampleKey } from './exampleContent'
import { RcsExampleModalContent } from './RcsExampleModalContent'

const MODAL_ID = 'rcsExampleModal'

export const openRcsExampleModal = (key: IRcsExampleKey, organizationName?: string) => {
  const { title, content } = RCS_EXAMPLE_CONTENT[key]
  const example =
    typeof content === 'string'
      ? applyOrganizationNamePlaceholder(content, organizationName)
      : content

  modalStore.addModal({
    id: MODAL_ID,
    width: 540,
    title,
    ModalContent: () => <RcsExampleModalContent example={example} />,
    primaryAction: {
      text: 'Done',
      onAction: () => modalStore.closeModal(MODAL_ID),
    },
    showCloseButton: false,
  })
}
